import React, {Component} from 'react';
import withUserRoleAuthorization from "../WithUserRoleAuthorization";
import {isNotGuestUser} from "../../utils/userRoles";
import UnitTabSwitcher from "./UnitTabSwitcher";
import {connect} from "react-redux";
import {compose} from "recompose";
import {ACTION_SET_SELECTED_UNIT} from "../../reducers/constants";
import {HOME} from "../../constants/routes";
import {withRouter} from "react-router-dom";

/**
 * The home page component that encapsulates the root directory components.
 */
class UnitPage extends Component {
    constructor(props){
        super(props);
        if (!props.selectedUnit) {
            props.history.push(HOME);
        }
    }

    componentWillUnmount() {
        // Reset the selected unit.
        this.props.onSetSelectedUnit(null);
    }

    render() {
        return (
            <div className="container">
                {
                    this.props.selectedUnit &&
                    <UnitTabSwitcher />
                }
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    selectedUnit: state.unitsState.selectedUnit
});

/**
 * Map Redux {@param dispatch} a.k.a. actions to component props
 */
const mapDispatchToProps = (dispatch) => ({
    onSetSelectedUnit: (selectedUnit) => dispatch({type: ACTION_SET_SELECTED_UNIT, selectedUnit})
});

/**
 * User authorization - returns {@code true} if not null (i.e. guest user)
 */
const isSignedInCondition = (authUser) => isNotGuestUser(authUser);

export default compose(
    withUserRoleAuthorization(isSignedInCondition),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(UnitPage);



// WEBPACK FOOTER //
// ./src/components/unit/UnitPage.jsx